<template>
  <div class="container-fluid compras-form-page">
    <div class="card-body h-100" v-if="!firstLoad">
      <div class="compras-form-layout">
        <nav class="compras-form-sidebar" aria-label="Etapas da compra">
          <button
            v-for="etapa in etapasCompra"
            :key="etapa.indice"
            type="button"
            class="compras-form-sidebar-item"
            :class="{ 'compras-form-sidebar-item-active': store.currentTab === etapa.indice }"
            :disabled="!podeNavegarParaEtapa(etapa.indice)"
            :aria-current="store.currentTab === etapa.indice ? 'step' : null"
            @click="selecionarEtapa(etapa.indice)"
          >
            {{ etapa.titulo }}
          </button>
        </nav>
        <div class="compras-form-content-card">
        <b-tabs class="compras-form-tabs" :class="{ 'compras-form-tabs--tabela': !importacaoManual && (store.currentTab === 3 || store.currentTab === 4), 'compras-form-tabs--pagamento': store.currentTab === 7 }" pills vertical nav-wrapper-class="compras-form-nav">
          <b-tab
            title="Informações fiscais"
            :active="store.currentTab === 1"
            :disabled="store.currentTab !== 1"
          >
            <b-card-text>Informações fiscais</b-card-text>
            <b-row>
              <b-col md="7">
                <b-form-group label="Natureza" label-for="natureza">
                  <VueSelect
                    ref="buscarNatureza"
                    input-id="natureza"
                    label="descricao"
                    v-model="form.natureza"
                    :options="naturezas"
                    :get-option-label="getNaturezaCompraLabel"
                    :loading="carregandoNaturezasCompra"
                    placeholder="Selecione a natureza de compra"
                    @open="carregarNaturezasCompra"
                    @input="setNatureza"
                  >
                    <template slot="no-options">
                      {{ carregandoNaturezasCompra ? "Carregando naturezas de compra..." : "Nenhuma natureza de compra encontrada" }}
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">{{ getNaturezaCompraLabel(option) }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ getNaturezaCompraLabel(option) }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="CFOP" label-for="cfop">
                  <b-form-input disabled id="cfop" name="cfop" v-model="cfop">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  id="numeroNFe"
                  label-for="numeroNFe"
                  label="Número"
                >
                  <b-form-input
                    id="numeroNFe"
                    name="numeroNFe"
                    v-model="$v.form.numeroNFe.$model"
                    :state="validateState('numeroNFe')"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="7">
                <b-form-group
                  id="chaveDeAcesso"
                  label-for="chaveDeAcesso"
                  label="Chave"
                >
                  <b-form-input
                    id="chaveDeAcesso"
                    name="chaveDeAcesso"
                    v-model="$v.form.chaveDeAcesso.$model"
                    :state="validateState('chaveDeAcesso')"
                    @keypress="permitirSomenteNumeros($event)"
                    maxlength="44"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group id="serieNFe" label-for="serieNFe" label="Série">
                  <b-form-input
                    id="serieNFe"
                    name="serieNFe"
                    v-model="$v.form.serieNFe.$model"
                    :state="validateState('serieNFe')"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  id="modeloNFe"
                  label-for="modeloNFe"
                  label="Modelo"
                >
                  <b-form-input
                    v-model="$v.form.modeloNFe.$model"
                    :state="validateState('modeloNFe')"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group
                  id="dataEmissao-grupo"
                  label-for="dataEmissao"
                  label="Data Emissão"
                >
                  <b-form-input
                    id="dataEmissao"
                    type="date"
                    :value="formatarDataCompra(form.dataEmissao)"
                    @input="$v.form.dataEmissao.$model = $event"
                    :state="validateState('dataEmissao')"
                    lang="pt-BR"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  id="dataEntrada-grupo"
                  label-for="dataEntrada"
                  label="Data Entrada"
                >
                  <b-form-input
                    id="dataEntrada"
                    type="date"
                    :value="formatarDataCompra(form.dataEntrada)"
                    @input="$v.form.dataEntrada.$model = $event"
                    :state="validateState('dataEntrada')"
                    lang="pt-BR"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab
            title="Fornecedor"
            :active="store.currentTab === 2"
            :disabled="store.currentTab !== 2"
          >
            <b-card-text>Fornecedor</b-card-text>
            <b-card-text
              >Para continuar, você deve preencher os dados referente ao
              Fornecedor.</b-card-text
            >
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Pesquisar Fornecedor"
                  label-for="fornecedor"
                >
                  <VueSelect
                    ref="buscarFornecedor"
                    :filterable="false"
                    v-model="fornecedor"
                    @input="setFornecedor"
                    :options="fornecedores"
                    @search="onSearchFornecedor"
                  >
                    <template slot="no-options">
                      Informe o nome do Fornecedor
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.nome }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.nome }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group id="cnpj_cpf" label-for="cnpj_cpf" label="CNPJ">
                  <b-form-input
                    v-if="hasCnpjAlfanumerico(formFornecedor.cnpj_cpf)"
                    disabled
                    id="cnpj_cpf"
                    name="cnpj_cpf"
                    :value="formatCpfCnpj(formFornecedor.cnpj_cpf)"
                  >
                  </b-form-input>
                  <b-form-input
                    v-else
                    disabled
                    id="cnpj_cpf"
                    name="cnpj_cpf"
                    v-model="formFornecedor.cnpj_cpf"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group id="ie_rg" label-for="ie_rg" label="IE">
                  <b-form-input
                    disabled
                    id="ie_rg"
                    name="ie_rg"
                    v-model="formFornecedor.ie_rg"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <b-form-group id="cep" label-for="cep" label="CEP">
                  <b-form-input
                    disabled
                    id="cep"
                    name="cep"
                    v-model="formFornecedor.cep"
                    v-mask="['#####-###']"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group
                  id="logradouro"
                  label-for="logradouro"
                  label="Endereço"
                >
                  <b-form-input
                    disabled
                    id="logradouro"
                    name="logradouro"
                    v-model="formFornecedor.logradouro"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  id="bairro"
                  label-for="bairro"
                  label="Bairro/Distrito"
                >
                  <b-form-input
                    disabled
                    id="bairro"
                    name="bairro"
                    v-model="formFornecedor.bairro"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="5">
                <b-form-group id="municipio" label-for="Cidade" label="Cidade">
                  <b-form-input
                    disabled
                    id="cidade"
                    name="cidade"
                    v-model="formFornecedor.cidade"
                    aria-describedby="cidade"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group id="uf" label-for="uf" label="UF">
                  <b-form-input
                    disabled
                    id="uf"
                    name="uf"
                    v-model="formFornecedor.uf"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group id="telefone" label="Telefone">
                  <b-form-input
                    disabled
                    v-mask="['(##) #### ####', '(##) # #### ####']"
                    v-model="formFornecedor.fone"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <button
                  class="btn btn-primary font-weight-bold"
                  @click="openNewFornecedor"
                >
                  Adicionar novo Fornecedor
                </button>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab
            title="Quantidade"
            :active="store.currentTab === 3"
            :disabled="store.currentTab !== 3"
            v-if="!importacaoManual"
          >
            <b-card-text class="compra-quantidade-instrucao">Informe a unidade de medida dos itens abaixo</b-card-text>
            <QuantidadesCompra
              :total="total"
              :items="productOfTradeCollection"
              @onItemsChange="
                (items) => (productOfTradeCollection = [...items])
              "
            />
          </b-tab>

          <b-tab
            title="Itens"
            :active="store.currentTab === 4"
            :disabled="store.currentTab !== 4"
            v-if="!importacaoManual"
          >
            <ItemsCompora
              :total="total"
              :items="productOfTradeCollection"
              :ativo="store.currentTab === 4"
              @onItemsChange="
                (items) => (productOfTradeCollection = [...items])
              "
            />
          </b-tab>

          <Produto v-if="importacaoManual" />

          <b-tab
            title="Impostos/Taxas"
            :active="store.currentTab === 5"
            :disabled="store.currentTab !== 5"
          >
            <div class="compras-impostos-layout">
              <section class="compras-impostos-secao" aria-labelledby="compra-impostos-titulo">
                <h6 id="compra-impostos-titulo">Impostos</h6>
                <div class="compras-impostos-campos">
                  <b-form-group label="Base ICMS" label-for="compra-base-icms">
                    <money
                      id="compra-base-icms"
                      class="form-control"
                      v-model="formImpostos.icmsBase"
                      v-bind="configMoney"
                    />
                  </b-form-group>
                  <b-form-group label="Valor ICMS" label-for="compra-valor-icms">
                    <money
                      id="compra-valor-icms"
                      class="form-control"
                      v-model="formImpostos.icmsValue"
                      v-bind="configMoney"
                    />
                  </b-form-group>
                  <b-form-group label="Base ICMS ST" label-for="compra-base-icms-st">
                    <money
                      id="compra-base-icms-st"
                      class="form-control"
                      v-model="formImpostos.icmsBaseST"
                      v-bind="configMoney"
                    />
                  </b-form-group>
                  <b-form-group label="Valor ICMS ST" label-for="compra-valor-icms-st">
                    <money
                      id="compra-valor-icms-st"
                      class="form-control"
                      v-model="formImpostos.sTValue"
                      v-bind="configMoney"
                    />
                  </b-form-group>
                  <b-form-group label="Valor FCP ST" label-for="compra-valor-fcp-st">
                    <money
                      id="compra-valor-fcp-st"
                      class="form-control"
                      v-model="formImpostos.vFCPST"
                      v-bind="configMoney"
                    />
                  </b-form-group>
                  <b-form-group label="Valor IPI" label-for="compra-valor-ipi">
                    <money
                      id="compra-valor-ipi"
                      class="form-control"
                      v-model="formImpostos.ipiValue"
                      v-bind="configMoney"
                    />
                  </b-form-group>
                </div>
              </section>

              <section class="compras-impostos-secao" aria-labelledby="compra-despesas-titulo">
                <h6 id="compra-despesas-titulo">Frete, despesas e desconto</h6>
                <div class="compras-impostos-campos">
                  <b-form-group label="Frete" label-for="compra-valor-frete">
                    <money
                      id="compra-valor-frete"
                      class="form-control"
                      v-model="formImpostos.valorFrete"
                      v-bind="configMoney"
                    />
                  </b-form-group>
                  <b-form-group label="Seguro" label-for="compra-valor-seguro">
                    <money
                      id="compra-valor-seguro"
                      class="form-control"
                      v-model="formImpostos.seguro"
                      v-bind="configMoney"
                    />
                  </b-form-group>
                  <b-form-group label="Outras Despesas" label-for="compra-outras-despesas">
                    <money
                      id="compra-outras-despesas"
                      class="form-control"
                      v-model="formImpostos.outrasDespesas"
                      v-bind="configMoney"
                    />
                  </b-form-group>
                  <b-form-group label="Desconto" label-for="compra-valor-desconto">
                    <money
                      id="compra-valor-desconto"
                      class="form-control"
                      v-model="formImpostos.desconto"
                      v-bind="configMoney"
                    />
                  </b-form-group>
                </div>
              </section>

              <section class="compras-impostos-totais" aria-label="Totais da compra">
                <div class="compras-impostos-total">
                  <b-form-group label="Total de Produtos" label-for="compra-total-produtos">
                    <money
                      id="compra-total-produtos"
                      class="form-control"
                      v-model="valorProdutos"
                      v-bind="configMoney"
                    />
                  </b-form-group>
                </div>
                <div class="compras-impostos-total compras-impostos-total--nota">
                  <b-form-group label="Total da Nota" label-for="compra-total-nota">
                    <money
                      id="compra-total-nota"
                      class="form-control"
                      :value="total"
                      readonly
                      v-bind="configMoney"
                    />
                  </b-form-group>
                </div>
              </section>
            </div>
          </b-tab>

          <b-tab
            title="Transportador / Volumes"
            :active="store.currentTab === 6"
            :disabled="store.currentTab !== 6"
          >
            <b-card-text>Transportador / Volumes</b-card-text>
            <b-row>
              <b-col md="5">
                <b-form-group label="Razão Social" label-for="transportador">
                  <VueSelect
                    ref="buscarTransportador"
                    :filterable="false"
                    v-model="transportador"
                    @input="setTransportador"
                    :options="transportadores"
                    @search="onSearchTransportador"
                  >
                    <template slot="no-options">
                      Informe o nome do Transportador
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.nome }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.nome }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group id="numero" label-for="numero" label="CPF/CNPJ">
                  <b-form-input
                    v-if="hasCnpjAlfanumerico(formTransportador.cnpj_cpf)"
                    disabled
                    id="cnpj_cpf"
                    name="cnpj_cpf"
                    :value="formatCpfCnpj(formTransportador.cnpj_cpf)"
                  >
                  </b-form-input>
                  <b-form-input
                    v-else
                    disabled
                    id="cnpj_cpf"
                    name="cnpj_cpf"
                    v-model="formTransportador.cnpj_cpf"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="8">
                <b-form-group
                  id="tipo_frete"
                  label-for="tipo_frete"
                  label="Frete"
                >
                  <VueSelect
                    ref="buscarTipoFrete"
                    :filterable="false"
                    v-model="formTransportador.tipo_frete"
                    :options="tiposFrete"
                  >
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo }} - {{ option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo }} - {{ option.descricao }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group id="veiculo" label-for="veiculo" label="Veículo">
                  <VueSelect
                    ref="buscarVeiculo"
                    :filterable="false"
                    v-model="formTransportador.veiculo"
                    :options="transportador.veiculos"
                  >
                    <template slot="no-options">
                      Informe o nome do Transportador
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.placa }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.placa }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group id="numero" label-for="numero" label="Endereço">
                  <VueSelect
                    ref="buscarEndereco"
                    :filterable="false"
                    v-model="formTransportador.endereco"
                    :options="transportador.enderecos"
                  >
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.cep }} - {{ option.logradouro }} -
                        {{ option.bairro }} - {{ option.cidade.cidade }}/{{
                          option.cidade.uf
                        }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.cep }} - {{ option.logradouro }} -
                        {{ option.bairro }} - {{ option.cidade.cidade }}/{{
                          option.cidade.uf
                        }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <hr />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <b-form-group label="Quantidade">
                  <money
                    class="form-control"
                    v-model="formTransportador.quantidade"
                    v-bind="quantityOptions"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Espécie">
                  <b-form-input
                    id="especie"
                    name="especie"
                    v-model="formTransportador.especie"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Marca">
                  <b-form-input
                    id="marca"
                    name="marca"
                    v-model="formTransportador.marca"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Peso Bruto">
                  <money
                    class="form-control"
                    v-model="formTransportador.pesoBruto"
                    v-bind="configMoney"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Peso Líquido">
                  <money
                    class="form-control"
                    v-model="formTransportador.pesoLiquido"
                    v-bind="configMoney"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Numeração">
                  <b-form-input
                    id="numeracao"
                    name="numeracao"
                    v-model="formTransportador.numeracao"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab
            title="Pagamento"
            :active="store.currentTab === 7"
            :disabled="store.currentTab !== 7"
          >
            <div class="compras-pagamento-campos">
              <b-form-group
                label="Forma de Pagamento"
                label-for="buscaPagamentosInput"
              >
                <VueSelect
                  label="descricao"
                  v-model="pagamento"
                  class="busca-cliente"
                  ref="buscaPagamentos"
                  id="buscaPagamentos"
                  input-id="buscaPagamentosInput"
                  :options="pagamentos"
                  @input="changePagamentos"
                >
                </VueSelect>
              </b-form-group>
              <b-form-group
                id="numero"
                label-for="numero"
                label="Valor (Enter)"
              >
                <InputMoney
                  ref="valorPagamento"
                  id="valorPagamento"
                  labelBold
                  inputClass="form-control input compras-pagamento-valor"
                  :onEnter="adicionarPagamento"
                  v-model="valorPgto"
                />
              </b-form-group>
              <b-form-group label="Plano de Contas" label-for="plano_contas">
                <VueSelect
                  @input="setPlanoContas"
                  @search="onSearchPlano"
                  ref="buscar_planos"
                  :filterable="false"
                  placeholder="Seleciona um plano de contas"
                  :options="plano_contas"
                  v-model="planoContasSelecionado"
                >
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.descricao }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.descricao }}
                    </div>
                  </template>
                </VueSelect>
              </b-form-group>
              <CentroCustoSelect v-model="form.id_centro_custo" />
            </div>

            <div class="compras-pagamento-adicionar">
              <button
                ref="addPagamento"
                type="button"
                class="btn btn-primary compras-pagamento-adicionar-btn font-weight-bold"
                @click="adicionarPagamento"
              >
                <span aria-hidden="true">+</span> Adicionar Pagamento
              </button>
            </div>

            <div class="compras-pagamento-tabelas">
              <section class="compras-pagamento-secao" aria-label="Parcelas">
                <h4>Parcelas</h4>
                <div class="compras-pagamento-tabela-scroll">
                <table class="compras-pagamento-tabela compras-pagamento-tabela--parcelas">
                  <thead>
                    <tr>
                      <th scope="col" class="compras-pagamento-numero">Nº</th>
                      <th scope="col">Forma de pagamento</th>
                      <th scope="col" class="compras-pagamento-valor">Valor R$</th>
                      <th scope="col" class="compras-pagamento-vencimento">Vencimento</th>
                    </tr>
                  </thead>
                  <tbody v-if="parcelasCompra.length">
                    <tr
                      v-for="parcela in parcelasCompra"
                      :key="`${parcela.pagamentoIndex}-${parcela.parcelaIndex}`"
                    >
                      <td>{{ parcela.parcelaIndex + 1 }}</td>
                      <td>{{ parcela.descricao }}</td>
                      <td class="compras-pagamento-valor">
                        <button
                          type="button"
                          class="compras-pagamento-editar"
                          @click="changePagamento(parcela.parcelaIndex, parcela.value, parcela.pagamentoIndex)"
                        >
                          {{ numberToReal(parcela.value, 2) }}
                        </button>
                      </td>
                      <td class="compras-pagamento-vencimento">
                        <button
                          type="button"
                          class="compras-pagamento-editar"
                          @click="selectVencimento(parcela.parcelaIndex, parcela.date, parcela.pagamentoIndex)"
                        >
                          {{ parcela.date | moment("DD/MM/YYYY") }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr><td colspan="4" class="compras-pagamento-vazio">Nenhuma parcela</td></tr>
                  </tbody>
                </table>
                </div>
                <div v-if="parcelasCompra.length" class="compras-pagamento-total">
                  <span>Total</span>
                  <strong>R$ {{ numberToReal(valorPago, 2) }}</strong>
                </div>
              </section>

              <section class="compras-pagamento-secao" aria-label="Pagamentos">
                <h4>Pagamentos</h4>
                <div class="compras-pagamento-tabela-scroll">
                <table class="compras-pagamento-tabela">
                  <thead>
                    <tr>
                      <th scope="col">Descrição</th>
                      <th scope="col" class="compras-pagamento-valor">Valor R$</th>
                      <th scope="col" class="compras-pagamento-acao">Ação</th>
                    </tr>
                  </thead>
                  <tbody v-if="listaPagamentos.length">
                    <tr v-for="(item, indice) in listaPagamentos" :key="indice">
                      <td>{{ item.descricao }}</td>
                      <td class="compras-pagamento-valor">
                        R$ {{ numberToReal(item.value, 2) }}
                      </td>
                      <td class="compras-pagamento-acao">
                        <button
                          type="button"
                          class="btn btn-sm btn-danger btn-hover-danger btn-icon"
                          :aria-label="`Remover pagamento ${item.descricao}`"
                          @click="removePagamento(indice)"
                        >
                          <TrashCanIcon :size="16" />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr><td colspan="3" class="compras-pagamento-vazio">Nenhum pagamento</td></tr>
                  </tbody>
                </table>
                </div>
              </section>
            </div>

            <b-form-group
              class="compras-pagamento-observacao"
              label="Informações Complementares"
            >
              <b-form-textarea
                id="observacao"
                name="observacao"
                v-model="form.observacao"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-tab>
        </b-tabs>
      <div class="card-footer compras-form-footer">
        <div class="row">
          <div class="col-lg-12" style="text-align: center">
            <div v-if="canSaveCompra">
              <button
                :disabled="store.currentTab === 1"
                class="btn btn-secondary font-weight-bold mr-4"
                @click="handlePrevious"
              >
                Anterior
              </button>
              <button
                type="submit"
                ref="submit_nova_compra"
                class="btn btn-primary font-weight-bold"
                @click="salvarCompra"
              >
                Salvar
              </button>
              <button
                ref="submit_previa_nfe"
                class="btn btn-clean font-weight-bold"
                @click="confirmCancel('comprasLista')"
              >
                Cancelar
              </button>
            </div>
            <div v-else>
              <button
                :disabled="store.currentTab === 1"
                class="btn btn-secondary font-weight-bold mr-4"
                @click="handlePrevious"
              >
                Anterior
              </button>
              <button
                class="btn btn-primary font-weight-bold"
                @click="handleNext"
                :disabled="store.currentTab === 7"
              >
                Proximo
              </button>
              <button
                ref="submit_previa_nfe"
                class="btn btn-clean font-weight-bold"
                @click="confirmCancel('comprasLista')"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-calendar" title="Ajustar vencimento" size="sm" centered>
      <div class="mx-auto">
        <b-calendar v-model="vencimentoSelected" locale="pt-BR"></b-calendar>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button
          variant="primary"
          @click="salvarVencimento"
          ref="transmitir_nfe"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-pagamento" title="Ajustar pagamento" size="sm" centered>
      <div class="mx-auto">
        <b-form class="form" @submit.stop.prevent="salvarPagamento">
          <money
            @input="changePagamentoEdited"
            class="form-control"
            id="valorPagamento"
            name="valorPagamento"
            :value="pagamentoSelected"
            v-bind="configMoney"
          >
          </money>
        </b-form>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button
          variant="primary"
          @click="salvarPagamento"
          ref="transmitir_nfe"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import FormatMixin from "../../Application/mixins/FormatMixin";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import CompraData, { CompraDataRequired } from "./CompraData";
import ImpostosData from "./ImpostosData";
import FornecedorData from "./FornecedorData";
import TransportadorData from "./TransportadorData";
import _ from "lodash";
import { mask } from "vue-the-mask";
import InputMoney from "../../Pdv/components/Form";
import { Money } from "v-money";
import {
  MONEY as settingMoney,
  quantityOptions,
  priceOptions,
} from "@/modules/Application";
import { QuantidadesCompra, ItemsCompora } from "./componentes";
import PagamentosMixin from "../../Pdv/mixins/PagamentosMixin";
import InstallmentsMixin from "../../Application/mixins/InstallmentsMixin";
import { store } from "../storeCompra";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import Produto from "./componentes/ProdutoTab.vue";
import swal from "sweetalert";
import CentroCustoSelect from "@/components/CentroCustoSelect/CentroCustoSelect.vue";

export default {
  name: "app-compra-form",
  props: {
    url: {
      type: String,
    },
    compra: {
      type: Object,
      default: () => {},
    },
  },
  directives: {
    mask,
  },
  components: {
    VueSelect,
    InputMoney,
    ItemsCompora,
    Money,
    QuantidadesCompra,
    TrashCanIcon,
    Produto,
    CentroCustoSelect,
  },
  mixins: [
    validationMixin,
    FormatMixin,
    SistemaMixin,
    ValidacaoMixin,
    PagamentosMixin,
    InstallmentsMixin,
  ],
  data() {
    return {
      store,
      form: {},
      quantityOptions,
      priceOptions,
      vencimentoSelected: null,
      indexVencimento: null,
      selectedPagamento: null,
      formaPagamentoSelecionada: null,
      pagamentoEditado: null,
      firstLoad: true,
      importacaoManual: false,
      maiorEtapaAcessada: 0,
      naturezaError: false,
      formFornecedor: {},
      formImpostos: {},
      pagamentoSelected: null,
      formTransportador: {},
      pagamentosEditados: [],
      formPagamento: {},
      naturezas: [],
      carregandoNaturezasCompra: false,
      naturezasCompraCarregadas: false,
      natureza: null,
      cfop: null,
      fornecedores: [],
      fornecedor: null,
      transportadores: [],
      transportador: {},
      hasXmlErrors: false,
      inputFilled: false,
      veiculo: {},
      configMoney: settingMoney,
      productOfTradeCollection: [],
      produtos: [],
      produto: null,
      valorTotal: "0",
      valorProdutos: "0",
      tiposFrete: [],
      pagamentos: [],
      valorPgto: 0,
      valorPagoCompra: 0,
      listaPagamentos: [],
      pagamento: {},
      plano_contas: [],
      multiplicar: 1,
      divisao: 2,
      planoContasSelecionado: null,
      applyingCfopAll: false,
      skipFirstNaturezaWatch: true,
    };
  },
  validations: {
    form: CompraDataRequired,
  },
  watch: {
    compra(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
        this.productOfTradeCollection = newValue.produtos;
        this.listaPagamentos = newValue.pagamentos;
        this.fornecedor = newValue.fornecedor;
        this.impostos = newValue.impostos;
        this.transportador = newValue.transportador;
      }
    },
    "store.formProduto": {
      handler(value) {
        this.productOfTradeCollection = value.produtos;
      },
      deep: true,
    },

    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valorTotal = newValue;
        this.checkValorPago();
      }
    },
    valorTotal(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (this.valorPgto === "R$ 0,00") {
          this.valorPgto = this.numberToReal(newValue, 2);
        }
      }
    },
    totalProdutos(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valorProdutos = newValue;
      }
    },
    valorPago(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.checkValorPago();
      }
    },
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (oldValue === 1 && newValue === 2) {
          if (!this.form.natureza) {
            this.$toast.error("Selecione uma natureza para prosseguir!");
            this.naturezaError = true;
            this.store.currentTab = oldValue;
          }
        }
        if (this.importacaoManual && oldValue === 3 && newValue === 4)
          this.store.currentTab = 5;
        if (this.store.currentTab === 1) this.carregarNaturezasCompra();
        this.$nextTick(() => {
          if (this.store.currentTab === newValue) {
            this.maiorEtapaAcessada = Math.max(this.maiorEtapaAcessada, newValue);
          }
        });
      }
    },
    "form.natureza": {
      async handler(newVal, oldVal) {
        if (this.applyingCfopAll) return;

        if (this.skipFirstNaturezaWatch) {
          this.skipFirstNaturezaWatch = false;
          return;
        }

        const oldCod = oldVal?.cfop || oldVal?.codigo || null;
        const newCod = newVal?.cfop || newVal?.codigo || null;

        if (!newCod || newCod === oldCod) return;

        const confirmed = await swal({
          title: "Aplicar CFOP em todos os itens?",
          text: `Deseja aplicar o CFOP ${newCod.codigo} para todos os itens desta compra?`,
          icon: "info",
          buttons: {
            confirm: { text: "Sim", visible: true, closeModal: false },
            cancel: { text: "Não", visible: true, closeModal: true },
          },
          dangerMode: false,
          closeModal: false,
          closeOnClickOutside: false,
        });

        if (confirmed) {
          try {
            this.applyingCfopAll = true;
            this.store.cfop = newCod;
            this.aplicarCfopNosItens(newCod);
            swal.close();
            swal.stopLoading();
          } finally {
            this.applyingCfopAll = false;
          }
        } else {
          swal.close();
          swal.stopLoading();
        }
      },
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
    }

    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }

    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    if (!Object.keys(this.$route.params).length) {
      this.importacaoManual = true;
      this.firstLoad = false;
      this.store.currentTab = 1;
      this.maiorEtapaAcessada = 1;
    }
  },
  async created() {
    this.store.currentTab = 0;
    this.getDataInit();
    if (this.$route.params?.xmlImportado) {
      await this.setNotaFiscal(this.$route.params.xmlImportado);
      this.firstLoad = false;
      this.store.currentTab = 1;
      this.maiorEtapaAcessada = 1;
      await this.$nextTick();
      this.$refs.buscarNatureza?.$refs.search?.focus();
    }
    if (this.$route?.params?.compraData) {
      const { compraData } = this.$route.params;
      this.firstLoad = false;
      this.importacaoManual = true;
      this.store.currentTab = 1;
      this.maiorEtapaAcessada = 1;
      this.natureza = compraData.natureza;
      this.form.natureza = compraData.natureza;
      this.cfop = compraData.natureza.cfop.codigo;
      this.form.dataEmissao = compraData.dataEmissao;
      this.form.dataEntrada = compraData.dataEntrada;
      this.form.chaveDeAcesso = compraData.chaveDeAcesso;
      this.form.serieNFe = compraData.serieNFe;
      this.form.modeloNFe = compraData.modeloNFe;
      this.form.numeroNFe = compraData.numeroNFe;
      this.formFornecedor = compraData.fornecedor;
      this.fornecedor = compraData.fornecedor;

      if (compraData.arquivoXml) {
        this.formFornecedor.cep = compraData.fornecedor.endereco[0].cep ?? null;
        this.formFornecedor.logradouro =
          compraData.fornecedor.endereco[0].logradouro ?? null;
        this.formFornecedor.numero =
          compraData.fornecedor.endereco[0].numero ?? null;
        this.formFornecedor.complemento =
          compraData.fornecedor.endereco[0].complemento ?? null;
        this.formFornecedor.bairro =
          compraData.fornecedor.endereco[0].bairro ?? null;
        this.formFornecedor.uf = compraData.fornecedor.endereco[0].uf ?? null;
        this.formFornecedor.cidade =
          compraData.fornecedor.endereco[0].cidade.cidade ?? null;
        this.formFornecedor.fone =
          compraData.fornecedor.telefone[0].fone ?? null;
      }
      this.planoContasSelecionado = compraData?.plano_contas ?? null;
      this.form.id_plano_contas = compraData?.plano_contas?.id ?? null;
      this.formImpostos = compraData.impostos;
      this.listaPagamentos = compraData.pagamentos;
      this.form.pagamentos = this.listaPagamentos;
      this.transportador = compraData?.transportador ?? {};
      this.formTransportador = compraData?.transportador ?? {};
      this.form.observacao = compraData?.observacao ?? "";
      this.form.id_centro_custo = compraData?.id_centro_custo ?? null;
    }
    if (this.$route.params?.id_manifesto) {
      this.setLoading(true);
      try {
        const response = await this.$http.post("/manifesto/importar-nfe", {
          id_manifesto: this.$route.params?.id_manifesto,
        });

        await this.setNotaFiscal(response.data);
        this.form.dataEntrada = this.thisDate();
        this.checkValorPago();

        this.store.currentTab = 1;
        this.maiorEtapaAcessada = 1;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        this.$toast.error("Não foi possível carregar os dados da compra.");
      } finally {
        this.setLoading(false);
        this.firstLoad = false;
      }
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    openNewFornecedor() {
      window.open(this.$router.resolve({ name: "pessoasNova" }).href, "_blank");
    },
    async getDataInit() {
      this.form = new CompraData({});
      this.formImpostos = new ImpostosData({});
      this.formFornecedor = new FornecedorData({});
      this.formTransportador = new TransportadorData({});
      this.tiposFrete = await this.getTiposFrete();
      this.getPagamentos();
      this.plano_contas = await this.getPlanoContas(1);
    },
    normalizeCfopCompra(cfopSelecionado) {
      if (!cfopSelecionado) return null;

      if (
        typeof cfopSelecionado === "string" ||
        typeof cfopSelecionado === "number"
      ) {
        return {
          id_cfop: undefined, // preencha se tiver
          descricao: undefined, // preencha se tiver
          codigo: String(cfopSelecionado),
          entrada: 1,
          saida: 0,
        };
      }

      const {
        id_cfop,
        descricao,
        codigo,
        entrada = 1,
        saida = 0,
      } = cfopSelecionado;

      return { id_cfop, descricao, codigo: String(codigo), entrada, saida };
    },

    aplicarCfopNosItens(cfopSelecionado, { sobrescrever = true } = {}) {
      const itens = this.productOfTradeCollection || [];
      const cfopCompra = this.normalizeCfopCompra(cfopSelecionado);
      if (!cfopCompra) return;

      itens.forEach((item, idx) => {
        const atual = item.cfop_compra || {};

        // só aplica se for sobrescrever ou se ainda não tem código
        if (sobrescrever || !atual.codigo) {
          // cria um objeto LIMPO, evitando o aninhamento errado
          const novo = {
            id_cfop: cfopCompra.id_cfop ?? atual.id_cfop,
            descricao: cfopCompra.descricao ?? atual.descricao,
            codigo: cfopCompra.codigo,
            entrada: cfopCompra.entrada ?? 1,
            saida: cfopCompra.saida ?? 0,
          };

          // garante reatividade
          this.$set(itens[idx], "cfop_compra", novo);

          // (opcional) manter “espelhos” se seu backend usa
          this.$set(itens[idx], "cfop", novo.codigo);
          if (novo.id_cfop !== undefined) {
            this.$set(itens[idx], "id_cfop", novo.id_cfop);
          }
        }

        // se por acaso já existe um aninhado indevido, remove
        if (itens[idx]?.cfop_compra?.cfop_compra) {
          this.$delete(itens[idx].cfop_compra, "cfop_compra");
        }
      });
    },
    permitirSomenteNumeros(event) {
      const charCode = event.charCode ? event.charCode : event.keyCode;
      // Permite apenas códigos de 48 a 57 (números de 0 a 9)
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    formatarDataCompra(value) {
      if (!value) return "";
      if (value instanceof Date) {
        if (Number.isNaN(value.getTime())) return "";
        const ano = value.getFullYear();
        const mes = String(value.getMonth() + 1).padStart(2, "0");
        const dia = String(value.getDate()).padStart(2, "0");
        return `${ano}-${mes}-${dia}`;
      }
      return String(value).slice(0, 10);
    },
    async salvarPagamento() {
      const pagamento = this.formaPagamentoSelecionada;
      if (!this.listaPagamentos.includes(pagamento)) return;

      const valorCentavos = Math.round(Number(this.pagamentoEditado) * 100);
      const editados = this.pagamentosEditados.filter(
        (item) => item.pagamento === pagamento && item.index !== this.selectedPagamento
      );
      editados.push({ pagamento, index: this.selectedPagamento, value: valorCentavos / 100 });
      const restante = Math.round(Number(pagamento.value) * 100) -
        editados.reduce((total, item) => total + Math.round(item.value * 100), 0);
      const quantidadeRestante = pagamento.range.length - editados.length;

      if (!Number.isFinite(valorCentavos) || valorCentavos < 0 || restante < 0 || (!quantidadeRestante && restante !== 0)) {
        this.$toast.warning("A soma das parcelas deve ser igual ao valor desta forma de pagamento.");
        return;
      }

      let parcelasDistribuidas = 0;
      pagamento.range = pagamento.range.map((item, index) => {
        const editado = editados.find((parcela) => parcela.index === index);
        if (editado) return { ...item, value: editado.value };
        const centavos = Math.floor(restante / quantidadeRestante) +
          (parcelasDistribuidas < restante % quantidadeRestante ? 1 : 0);
        parcelasDistribuidas++;
        return { ...item, value: centavos / 100 };
      });
      this.pagamentosEditados = [
        ...this.pagamentosEditados.filter((item) => item.pagamento !== pagamento),
        ...editados,
      ];
      this.$bvModal.hide("modal-pagamento");
    },
    selectVencimento(index, date, pagamentoIndex = 0) {
      this.formaPagamentoSelecionada = this.listaPagamentos[pagamentoIndex];
      this.indexVencimento = index;
      this.vencimentoSelected = date;
      this.$bvModal.show("modal-calendar");
    },
    changePagamento(pagamentoIndex, value, formaPagamentoIndex = 0) {
      this.formaPagamentoSelecionada = this.listaPagamentos[formaPagamentoIndex];
      this.selectedPagamento = pagamentoIndex;
      this.pagamentoSelected = value;
      this.pagamentoEditado = value;
      this.$bvModal.show("modal-pagamento");
    },
    changePagamentoEdited(valor) {
      this.pagamentoEditado = valor;
    },
    salvarVencimento() {
      const pagamento = this.formaPagamentoSelecionada;
      if (!this.listaPagamentos.includes(pagamento)) return;
      this.$set(pagamento.range[this.indexVencimento], "date", this.vencimentoSelected);
      this.$bvModal.hide("modal-calendar");
    },
    handleNext() {
      if (this.store.currentTab === 7) return;
      this.store.currentTab++;
    },
    podeNavegarParaEtapa(indice) {
      return indice <= this.maiorEtapaAcessada;
    },
    async selecionarEtapa(indice) {
      if (!this.podeNavegarParaEtapa(indice) || indice === this.store.currentTab) return;
      if (indice < this.store.currentTab) {
        this.store.currentTab = indice;
        return;
      }
      while (this.store.currentTab < indice) {
        const etapaAnterior = this.store.currentTab;
        this.handleNext();
        await this.$nextTick();
        if (this.store.currentTab <= etapaAnterior) return;
      }
    },
    handlePrevious() {
      if (this.store.currentTab === 1) return;
      if (this.importacaoManual && this.store.currentTab === 5) {
        this.store.currentTab = 3;
        return;
      }
      this.store.currentTab--;
    },
    removeItem(index) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Deseja remover o item?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.productOfTradeCollection.splice(index, 1);
            this.$alert.success("Item removido com sucesso!");
          }
        });
    },
    getNaturezaCompraLabel(natureza) {
      return [natureza.descricao, natureza.cfop?.codigo].filter(Boolean).join(" - ");
    },
    async carregarNaturezasCompra() {
      if (this.naturezasCompraCarregadas || this.carregandoNaturezasCompra) return;
      this.carregandoNaturezasCompra = true;
      try {
        const naturezas = await this.getNaturezaByDescricao("");
        this.naturezas = naturezas.filter(
          (natureza) => Number(natureza?.cfop?.entrada) === 1
        );
        this.naturezasCompraCarregadas = true;
      } catch (error) {
        this.naturezas = [];
        this.$toast.error("Não foi possível buscar as naturezas de compra.");
      } finally {
        this.carregandoNaturezasCompra = false;
      }
    },

    setNatureza(natureza) {
      this.form.natureza = natureza;
      this.cfop = natureza?.cfop?.codigo ?? null;
      this.naturezaError = false;
      this.store.cfop_compra = natureza;
      this.natureza = natureza;
    },

    hasCnpjAlfanumerico(valor) {
      return /[A-Za-z]/.test(String(valor || ""));
    },

    onSearchFornecedor(search, loading) {
      if (search.length) {
        loading(true);
        this.searchFornecedor(loading, search, this);
      }
    },

    searchFornecedor: _.debounce(async (loading, search, vm) => {
      vm.fornecedores = await vm.getFornecedorByNome(search);
      loading(false);
    }, 350),

    onSearchTransportador(search, loading) {
      if (search.length) {
        loading(true);
        this.searchTransportador(loading, search, this);
      }
    },

    searchTransportador: _.debounce(async (loading, search, vm) => {
      vm.transportadores = await vm.getTransportadorByNome(search);
      loading(false);
    }, 350),

    setFornecedor(fornecedor) {
      this.formFornecedor = fornecedor;
      this.formFornecedor.cep = fornecedor.enderecos[0].cep ?? null;
      this.formFornecedor.logradouro =
        fornecedor.enderecos[0].logradouro ?? null;
      this.formFornecedor.numero = fornecedor.enderecos[0].numero ?? null;
      this.formFornecedor.complemento =
        fornecedor.enderecos[0].complemento ?? null;
      this.formFornecedor.bairro = fornecedor.enderecos[0].bairro ?? null;
      this.formFornecedor.uf = fornecedor.enderecos[0].cidade.uf ?? null;
      this.formFornecedor.cidade =
        fornecedor.enderecos[0].cidade.cidade ?? null;
      this.formFornecedor.fone = fornecedor.fones[0].fone ?? null;
    },

    onSearchPlano(search, loading) {
      if (search.length) {
        loading(true);
        this.searchPlano(loading, search, this);
      }
    },
    searchPlano: _.debounce(async (loading, search, vm) => {
      vm.plano_contas = await vm.getPlanoContasContaPagar(search);
      loading(false);
    }, 450),

    setTransportador(transportador) {
      this.formTransportador = transportador;
    },

    setPlanoContas(planoContas) {
      this.planoContasSelecionado = planoContas;
      this.form.id_plano_contas = planoContas.id;
      this.form.plano_contas = planoContas;
    },

    async setNotaFiscal(notafiscal) {
      this.form = notafiscal;
      this.productOfTradeCollection = notafiscal.produtos;

      if (this.productOfTradeCollection) {
        await this.productOfTradeCollection.map((item, key) => {
          if (typeof item.vinculoProduto !== "undefined") {
            this.productOfTradeCollection[key].unidade_medida =
              item.vinculoProduto.unidade_medida;

            if (!this.productOfTradeCollection[key].unidade_medida) {
              this.productOfTradeCollection[key].quantidade_conversao =
                item.quantidade;
              return;
            }

            if (
              this.productOfTradeCollection[key].unidade_medida
                .tipo_conversor == this.multiplicar
            ) {
              this.productOfTradeCollection[key].quantidade_conversao =
                this.productOfTradeCollection[key].quantidade_conversao *
                this.productOfTradeCollection[key].unidade_medida.conversor;

              return;
            }

            if (
              this.productOfTradeCollection[key].unidade_medida
                .tipo_conversor == this.divisao
            ) {
              this.productOfTradeCollection[key].quantidade_conversao =
                this.productOfTradeCollection[key].quantidade_conversao /
                this.productOfTradeCollection[key].unidade_medida.conversor;

              return;
            }
          }
        });
      }

      if (notafiscal.fornecedor) {
        this.fornecedor = notafiscal.fornecedor;
        const endereco = notafiscal.fornecedor.endereco?.[0];
        this.formFornecedor = {
          ...notafiscal.fornecedor,
          ...endereco,
          cidade: endereco?.cidade?.cidade ?? null,
          fone: notafiscal.fornecedor.telefone?.[0]?.fone ?? null,
        };
      }

      if (notafiscal.impostos) {
        this.formImpostos.desconto =
          (await notafiscal.impostos.desconto) ?? null;
        this.formImpostos.descontoPorcentagem =
          notafiscal.impostos.descontoPorcentagem ?? null;
        this.formImpostos.icmsBase =
          (await notafiscal.impostos.icmsBase) ?? null;
        this.formImpostos.icmsValue =
          (await notafiscal.impostos.icmsValue) ?? null;
        this.formImpostos.ipiValue =
          (await notafiscal.impostos.ipiValue) ?? null;
        this.formImpostos.outrasDespesas =
          notafiscal.impostos.outrasDespesas ?? null;
        this.formImpostos.sTValue = (await notafiscal.impostos.sTValue) ?? null;
        this.formImpostos.seguro = (await notafiscal.impostos.seguro) ?? null;
        this.formImpostos.vFCPST = (await notafiscal.impostos.vFCPST) ?? null;
        this.valorProdutos = (await notafiscal.impostos.totalProdutos) ?? null;
        this.valorTotal = (await notafiscal.impostos.valor) ?? null;
        this.formImpostos.valorFrete =
          (await notafiscal.impostos.valorFrete) ?? null;
      }

      if (notafiscal.transportador) {
        this.transportador = notafiscal.transportador;
        this.formTransportador = {
          ...notafiscal.transportador,
          ...notafiscal.transportador.vol,
          tipo_frete: notafiscal.transportador.mod_frete ?? 9,
        };
      }

      if (notafiscal.pagamentos) {
        this.listaPagamentos.push(notafiscal.pagamentos);
      }
    },

    async salvarCompra() {
      const submitButton = this.$refs["submit_nova_compra"];
      if (parseFloat(this.valorPagoCompra) > 0) {
        if (
          parseFloat(this.valorPagoCompra).toFixed(0) <
          parseFloat(this.total).toFixed(0)
        ) {
          return this.$toast.warning(
            "Valor pago deve ser igual ao total da compra!"
          );
        }
      }

      if (this.natureza == null) {
        this.$toast.warning("Selecione a natureza de operação!");
        return;
      }

      if (this.fornecedor == null) {
        this.$toast.warning("Selecione a fornecedor!");
        return;
      }

      const produtoSemLote = this.productOfTradeCollection.find((item) => {
        const controlaLote = this.importacaoManual
          ? item?.lote
          : item?.vinculoProduto?.lote;

        return controlaLote && !item?.lote_baixa;
      });

      if (produtoSemLote) {
        const descricao = produtoSemLote?.vinculoProduto?.descricao
          || produtoSemLote?.descricao
          || produtoSemLote?.produto?.descricao
          || "selecionado";
        this.$toast.warning(
          `Selecione um lote existente ou cadastre um novo lote para o produto ${descricao}.`
        );
        return;
      }

      if (this.listaPagamentos.length === 0) {
        this.$toast.warning("Informe ao menos um pagamento!");
        return;
      }

      let produtosSemUN = [];
      if (this.productOfTradeCollection) {
        this.productOfTradeCollection.map((item, key) => {
          if (!item.unidade_medida) {
            key = key + 1;
            produtosSemUN.push(key);
          }
        });
      }

      if (produtosSemUN.length > 0) {
        const message = !this.importacaoManual
          ? "Selecione uma unidade medida do item da posição: " + produtosSemUN
          : "Produto cadastrado sem unidade de medida! Produto da posição: " +
            produtosSemUN;
        return this.$toast.warning(message);
      }
      if (this.listaPagamentos.length === 0) {
        return this.$toast.warning("Selecione uma forma de pagamento!");
      }

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        this.form.impostos = this.formImpostos;
        this.form.impostos.valor = this.total;
        this.form.impostos.totalProdutos = this.valorProdutos;
        this.form.fornecedor = this.fornecedor;
        this.form.transportador = this.transportador;
        this.form.produtos = this.productOfTradeCollection;
        this.form.pagamentos = this.listaPagamentos;

        if (this.importacaoManual)
          this.form = {
            ...this.form,
            importacao_manual: true,
          };

        if (this.$route.params?.compraData) {
          await this.$http.post("/compras/update", {
            id: this.$route.params?.compraData?.id,
            ...this.form,
          });
        } else await this.$http.post(this.url, this.form);

        this.$router.push({ name: "comprasLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
    changePagamentos(selectedPagamento) {
      this.pagamento = selectedPagamento;
      this.$nextTick(() => {
        this.$refs.valorPagamento.$el.querySelector("input").focus();
      });
    },
    checkValorPago() {
      this.valorPagoCompra = this.valorPago;
      const valorPagar = Math.max(0, Number(this.total) - this.valorPagoCompra);
      this.valorPgto = this.valorReal(valorPagar);
    },
    async adicionarPagamento() {
      const valor = await this.valorUS(this.valorPgto);

      let pagamento = {
        value: valor,
        ...this.pagamento,
      };

      if (
        (valor > 0 && pagamento.descricao) ||
        pagamento.descricao === "Nenhum"
      ) {
        const range =
          pagamento.descricao !== "Nenhum"
            ? this.calculateInstallments(pagamento, parseFloat(pagamento.value))
            : [
                {
                  date: "-",
                  value: 0,
                },
              ];

        pagamento = {
          ...pagamento,
          range,
        };

        this.listaPagamentos.push(pagamento);

        this.checkValorPago();

        this.changePagamentos({});

        this.$alert.success("Adicionado com sucesso!");
      }
    },
    removePagamento(indice) {
      const [removido] = this.listaPagamentos.splice(indice, 1);
      this.pagamentosEditados = this.pagamentosEditados.filter((item) => item.pagamento !== removido);
      this.checkValorPago();
      this.$alert.success("Removido com sucesso!");
      this.$nextTick(() => {
        this.$refs.buscaPagamentos.$el.querySelector("input").focus();
      });
    },
    getRangePayment(payment) {
      if (!payment) return 0;
      return payment.reduce((total, item) => total + item.value, 0);
    },
  },
  computed: {
    parcelasCompra() {
      return this.listaPagamentos.reduce((parcelas, pagamento, pagamentoIndex) => {
        (pagamento.range || []).forEach((parcela, parcelaIndex) => {
          parcelas.push({ ...parcela, descricao: pagamento.descricao, pagamentoIndex, parcelaIndex });
        });
        return parcelas;
      }, []);
    },
    etapasCompra() {
      return this.importacaoManual
        ? [
            { indice: 1, titulo: "Informações fiscais" },
            { indice: 2, titulo: "Fornecedor" },
            { indice: 3, titulo: "Produtos" },
            { indice: 5, titulo: "Impostos/Taxas" },
            { indice: 6, titulo: "Transportador / Volumes" },
            { indice: 7, titulo: "Pagamento" },
          ]
        : [
            { indice: 1, titulo: "Informações fiscais" },
            { indice: 2, titulo: "Fornecedor" },
            { indice: 3, titulo: "Quantidade" },
            { indice: 4, titulo: "Itens" },
            { indice: 5, titulo: "Impostos/Taxas" },
            { indice: 6, titulo: "Transportador / Volumes" },
            { indice: 7, titulo: "Pagamento" },
          ];
    },
    total() {
      const produtos = this.productOfTradeCollection;
      const aux = produtos.reduce((total, item) => total + item.total, 0);
      let valor = isNaN(aux) ? 0 : aux;

      if (this.formImpostos.desconto) {
        valor -= this.formImpostos.desconto;
      }

      if (this.formImpostos.outrasDespesas) {
        valor += parseFloat(this.formImpostos.outrasDespesas);
      }

      if (this.formImpostos.seguro) {
        valor += parseFloat(this.formImpostos.seguro);
      }

      if (this.formImpostos.valorFrete) {
        valor += parseFloat(this.formImpostos.valorFrete);
      }

      if (this.formImpostos.ipiValue) {
        valor += parseFloat(this.formImpostos.ipiValue);
      }

      if (this.formImpostos.sTValue) {
        valor += parseFloat(this.formImpostos.sTValue);
      }

      if (this.formImpostos.vFCPST) {
        valor += parseFloat(this.formImpostos.vFCPST);
      }

      return valor.toFixed(2);
    },
    totalProdutos() {
      const produtos = this.productOfTradeCollection;
      let valor = produtos.reduce((total, item) => total + item.total, 0);

      return valor;
    },
    valorPagamento() {
      if (this.listaPagamentos.length === 0) return 0;
      else return this.listaPagamentos[0].valor;
    },
    canSaveCompra() {
      return this.store.currentTab === 7;
    },
    valorPago() {
      if (!this.listaPagamentos || !this.listaPagamentos?.length) {
        return 0;
      }

      return this.listaPagamentos.reduce(
        (total, item) => total + this.getRangePayment(item?.range),
        0
      );
    },
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    toolbarDisplay() {
      return true;
    },
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    displaySubheaderOnDashboard() {
      return this.$route.name !== "dashboard";
    },
  },
};
</script>

<style>
.hasErrors .vs__dropdown-toggle {
  border: 2px solid red;
}

.hasErrors .vs__clear,
.hasErrors .vs__open-indicator {
  fill: red;
}

.inputFilled .vs__dropdown-toggle {
  border: 2px solid #1bc5bd;
  /* color: #394066; */
}

.inputFilled .vs__clear,
.inputFilled .vs__open-indicator {
  fill: #1bc5bd;
}

.xmlError .custom-file-input {
  border: 2px solid red;
}

.busca-produto .vs__search {
  font-weight: 400;
  font-size: 1.45rem !important;
  margin-bottom: 0.5rem !important;
  line-height: 1.2 !important;
  text-transform: uppercase !important;
}

.busca-produto .vs__dropdown-toggle {
  border: 0px !important;
}

.busca-produto .vs__actions {
  display: none;
}

.busca-produto .vs__selected-options {
  max-width: 100%;
  flex-wrap: initial;
}

.busca-produto .vs__selected {
  text-align: left !important;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.busca-cliente .vs__search {
  font-size: 18px;
}

.busca-cliente .vs__dropdown-toggle {
  color: var(--primary-color);
  background-color: #fff;
  border: 2px solid #dedede;
  height: 40px;
}

.busca-cliente .vs--open .vs__dropdown-toggle {
  background-color: #fff;
  border: 2px solid var(--primary-color);
}

.busca-cliente .vs__actions {
  display: none;
}

.busca-cliente .vs__dropdown-option--highlight,
.vs__dropdown-menu li:hover,
.vs__dropdown-menu li:focus {
  background-color: var(--primary-color) 5e !important;
  color: var(--primary-color) !important;
}

.busca-cliente .vs__dropdown-menu {
  color: var(--primary-color) !important;
}

.busca-cliente .vs__selected-options {
  max-width: 100%;
  flex-wrap: initial;
}

.busca-cliente .vs__selected {
  text-align: left !important;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.remove-pgto {
  font-weight: bold;
  font-size: 18px;
  color: #4f4f4f;
}

.add-pgto {
  font-weight: bold;
  font-size: 22px;
  color: var(--primary-color);
  float: right;
}

.input-quantidade {
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  background: transparent;
  border: transparent;
  color: #fff;
  padding: 0px;
  margin-top: -10px;
  margin-bottom: 0px;
  text-align: right;
}

.input-quantidade:focus {
  box-shadow: 0 0 0 0;
  border: 0 none;
  outline: 0;
  border: 0px;
  background-color: transparent;
  color: #fff;
}

.card {
  border: 0;
}

h4 {
  color: #6d747c;
  /* font-weight: 900; */
}

.btn-finalizar-venda {
  background-color: #eee5ff !important;
  font-size: 1.25rem !important;
  text-align: center !important;
  cursor: pointer;
}

.card-total-right p,
.card-total-left p {
  color: #fff !important;
}

.card-header h5,
.card-header h3 {
  margin-bottom: 0rem;
}

.card-header .form-control {
  height: auto;
  margin-top: 0px;
}

.card-header .busca-produto {
  margin-top: 2px;
}

.card-titulo-itens .card-body {
  padding: 5px 0 !important;
}

.card-itens .table tr th {
  padding: 5px;
  font-size: 12px;
}

.card-itens .table tr td,
.card-total-right p,
.card-total-left p {
  font-size: 12px;
}

.compras-form-page {
  flex: 1 1 0;
  min-height: 0;
  padding: 16px;
  overflow: hidden;
}

.compras-form-page > .card-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
  padding: 0;
}

.wrapper:has(.compras-form-page) {
  height: 100dvh;
  max-height: 100dvh;
  min-height: 0;
  overflow: hidden;
}

.wrapper:has(.compras-form-page) > #kt_footer {
  background: transparent !important;
}

#kt_content:has(.compras-form-page) {
  flex: 1 1 0;
  overflow: hidden;
}

#kt_content:has(.compras-form-page),
#kt_content:has(.compras-form-page) > .d-flex.flex-column-fluid,
#kt_content:has(.compras-form-page) > .d-flex.flex-column-fluid > .container,
#kt_content:has(.compras-form-page) > .d-flex.flex-column-fluid > .container-fluid,
#kt_content:has(.compras-form-page) .content-wrapper {
  min-height: 0;
}

#kt_content:has(.compras-form-page) > .d-flex.flex-column-fluid,
#kt_content:has(.compras-form-page) > .d-flex.flex-column-fluid > .container,
#kt_content:has(.compras-form-page) > .d-flex.flex-column-fluid > .container-fluid,
#kt_content:has(.compras-form-page) .content-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
}

#kt_content:has(.compras-form-page) .d-lg-flex.flex-row-fluid {
  display: flex;
  flex: 1 1 0;
  min-height: 0;
}

#kt_content:has(.compras-form-page) .content-wrapper,
#kt_content:has(.compras-form-page) > .d-flex.flex-column-fluid {
  overflow: hidden;
}

.compras-form-layout {
  display: grid;
  flex: 1 1 0;
  min-height: 0;
  width: 100%;
  grid-template-columns: 240px minmax(0, 1fr);
  align-items: stretch;
  gap: 16px;
}

.compras-form-sidebar,
.compras-form-content-card {
  min-width: 0;
  min-height: 0;
  border: 1px solid #e6eaf0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(39, 61, 89, 0.04);
}

.compras-form-sidebar {
  display: flex;
  flex-direction: column;
  align-self: start;
  gap: 4px;
  padding: 8px;
  max-height: 100%;
  overflow-y: auto;
}

.compras-form-sidebar-item {
  width: 100%;
  padding: 11px 13px;
  border: 0;
  border-left: 3px solid transparent;
  border-radius: 5px;
  background: transparent;
  color: #4b5563;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  text-align: left;
  cursor: pointer;
}

.compras-form-sidebar-item:hover:not(:disabled) {
  background: #fff7f4;
  color: #b84b36;
}

.compras-form-sidebar-item:focus-visible {
  outline: 2px solid #ee7361;
  outline-offset: 2px;
}

.compras-form-sidebar-item-active,
.compras-form-sidebar-item-active:hover:not(:disabled) {
  border-left-color: #ee7361;
  background: #fff0eb;
  color: #ad422d;
}

.compras-form-sidebar-item:disabled:not(.compras-form-sidebar-item-active) {
  color: #9ca3af;
  cursor: not-allowed;
}

.compras-form-content-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  container: compra / inline-size;
}

.compras-form-tabs.tabs.row {
  display: block;
  flex: 1 1 0;
  min-height: 0;
  margin: 0;
  padding: 24px 26px;
  overflow-y: auto;
}

.compras-form-tabs > .compras-form-nav {
  display: none !important;
}

.compras-form-tabs > .tab-content {
  min-width: 0;
  padding: 0;
}

.compras-form-tabs--tabela.tabs.row,
.compras-form-tabs--tabela > .tab-content,
.compras-form-tabs--tabela .tab-pane.active,
.compras-form-tabs--tabela .tab-pane.active > div,
.compras-form-tabs--tabela .tab-pane.active > .row > .col-md-12,
.compras-form-tabs--tabela .tab-pane.active > div > .row,
.compras-form-tabs--tabela .tab-pane.active > div > .row > .col-md-12,
.compras-form-tabs--tabela .compra-xml-table,
.compras-form-tabs--tabela .compra-xml-table > .card-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
}

.compras-form-tabs--tabela.tabs.row {
  overflow: hidden;
}

.compras-form-tabs--tabela .compra-xml-table-scroll {
  flex: 1 1 0;
  min-height: 0;
  max-height: none !important;
  overflow: auto;
}

.compras-form-footer {
  flex: 0 0 auto;
  padding: 14px 20px;
  border-top: 1px solid #e6eaf0;
  background: #fff;
}

.compras-pagamento-campos {
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 1.5fr) minmax(0, 2.5fr) minmax(0, 3fr);
  gap: 16px;
  align-items: start;
}

.compras-pagamento-campos > .form-group {
  min-width: 0;
  margin-bottom: 0;
}

.compras-pagamento-valor {
  height: 44px;
}

.compras-pagamento-adicionar {
  display: flex;
  justify-content: flex-start;
  margin: 12px 0 16px;
}

.compras-pagamento-adicionar .compras-pagamento-adicionar-btn {
  padding: 6px 10px;
  border-color: #ee7361;
  background: #ee7361;
  color: #fff;
}

.compras-pagamento-adicionar .compras-pagamento-adicionar-btn:not(:disabled):hover,
.compras-pagamento-adicionar .compras-pagamento-adicionar-btn:not(:disabled):focus {
  border-color: #dc6655;
  background: #dc6655;
  color: #fff;
}

.compras-pagamento-tabelas {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: stretch;
}

.compras-pagamento-secao {
  display: flex;
  flex-direction: column;
  height: 350px;
  min-width: 0;
  border: 1px solid #e3e8ef;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
}

.compras-pagamento-secao h4 {
  flex: 0 0 auto;
  margin: 0;
  padding: 11px 14px;
  background: #f8fafc;
  color: #17213a;
  font-size: 15px;
  font-weight: 700;
}

.compras-pagamento-tabela-scroll {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  overflow-x: auto;
}

.compras-pagamento-tabela {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  color: #26334a;
  font-size: 13px;
}

.compras-pagamento-tabela th,
.compras-pagamento-tabela td {
  padding: 9px 12px;
  border-top: 1px solid #e9edf2;
  overflow-wrap: anywhere;
}

.compras-pagamento-tabela thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f1f4f8;
  color: #5f6b80;
  font-weight: 600;
}

.compras-pagamento-tabela .compras-pagamento-valor {
  text-align: right;
}

.compras-pagamento-tabela--parcelas .compras-pagamento-numero {
  width: 36px;
}

.compras-pagamento-tabela--parcelas .compras-pagamento-valor,
.compras-pagamento-tabela--parcelas .compras-pagamento-vencimento {
  width: 26%;
}

.compras-pagamento-tabela--parcelas .compras-pagamento-valor {
  text-align: center;
}

.compras-pagamento-tabela--parcelas .compras-pagamento-vencimento {
  text-align: right;
}

.compras-pagamento-tabela .compras-pagamento-acao {
  width: 76px;
  text-align: center;
}

.compras-pagamento-total {
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border-top: 1px solid #e9edf2;
  background: #f1f4f8;
  font-weight: 700;
}

.compras-pagamento-tabela .compras-pagamento-vazio {
  padding: 18px 12px;
  color: #7a8495;
  text-align: center;
}

.compras-pagamento-editar {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: inherit;
  cursor: pointer;
}

.compras-pagamento-editar:hover,
.compras-pagamento-editar:focus-visible {
  color: #ee7361;
  text-decoration: underline;
}

.compras-pagamento-observacao {
  margin: auto 0 0;
  padding-top: 16px;
}

.compras-form-tabs--pagamento.tabs.row {
  display: flex;
  flex-direction: column;
}

.compras-form-tabs--pagamento > .tab-content {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  min-height: 100%;
}

.compras-form-tabs--pagamento .tab-pane.active {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 100%;
}

@media (max-width: 1399px) {
  .compras-pagamento-campos {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1050px) {
  .compras-pagamento-tabelas {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 640px) {
  .compras-pagamento-campos {
    grid-template-columns: minmax(0, 1fr);
  }
}

.compras-impostos-layout {
  display: grid;
  gap: 16px;
}

.compras-impostos-totais {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.compras-impostos-total {
  min-width: 0;
  padding: 14px 16px;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  background: #f7f9fc;
}

.compras-impostos-total--nota {
  border-left: 4px solid var(--color-primary, #ef6f61);
  background: #fff5f2;
}

.compras-impostos-secao {
  min-width: 0;
  padding: 16px;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
}

.compras-impostos-secao h6 {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 700;
}

.compras-impostos-campos {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
}

.compras-impostos-layout .form-group {
  min-width: 0;
  margin-bottom: 0;
}

.compras-form-tabs .compra-xml-table {
  width: 100%;
  min-width: 0;
  height: auto !important;
  max-height: none !important;
  overflow: visible;
}

.compras-form-tabs .compra-xml-table > .card-body {
  min-width: 0;
}

.compras-form-tabs .compra-xml-table-scroll {
  width: 100%;
  overflow: auto;
}

.compras-form-tabs .compra-quantidade-instrucao {
  margin-bottom: 6px;
  font-size: 12px;
  line-height: 1.3;
}

.compras-form-tabs .compra-xml-table-scroll > .table {
  width: 100%;
  min-width: 0;
  table-layout: fixed;
}

.compras-form-tabs .compra-xml-table-scroll td {
  padding: 6px !important;
  vertical-align: middle;
  overflow-wrap: anywhere;
}

.compras-form-tabs .compra-xml-table-scroll .form-control {
  height: 32px;
  padding: 4px 8px;
  font-size: 12px;
}

.compras-form-tabs .compra-xml-table-scroll .btn {
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1.25;
}

.compras-form-tabs .compra-quantidade-descricao {
  display: flex;
  align-items: center;
  gap: 6px;
}

.compras-form-tabs .compra-quantidade-descricao > .btn {
  flex: 0 0 auto;
}

.compras-form-tabs .compra-xml-table-scroll th {
  padding: 6px !important;
  overflow-wrap: anywhere;
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f7f9fc;
}

.compras-form-tabs .compra-xml-table-scroll::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.compras-form-tabs .compra-xml-table-scroll::-webkit-scrollbar-thumb {
  background: #b5b5c3;
  border-radius: 3px;
}


.compras-form-tabs--tabela.tabs.row {
  padding: 12px;
}

.compras-form-tabs .compra-xml-table-scroll .form-control,
.compras-form-tabs .compra-xml-table-scroll .v-select {
  min-width: 0;
  width: 100%;
}

.compras-form-tabs .compra-quantidades-tabela col:nth-child(1) { width: 4%; }
.compras-form-tabs .compra-quantidades-tabela col:nth-child(2) { width: 28%; }
.compras-form-tabs .compra-quantidades-tabela col:nth-child(3) { width: 9%; }
.compras-form-tabs .compra-quantidades-tabela col:nth-child(4) { width: 15%; }
.compras-form-tabs .compra-quantidades-tabela col:nth-child(5) { width: 13%; }
.compras-form-tabs .compra-quantidades-tabela col:nth-child(6) { width: 12%; }
.compras-form-tabs .compra-quantidades-tabela col:nth-child(7) { width: 3%; }
.compras-form-tabs .compra-quantidades-tabela col:nth-child(8) { width: 16%; }
.compras-form-tabs .compra-itens-tabela col:nth-child(1) { width: 4%; }
.compras-form-tabs .compra-itens-tabela col:nth-child(2) { width: 8%; }
.compras-form-tabs .compra-itens-tabela col:nth-child(3) { width: 33%; }
.compras-form-tabs .compra-itens-tabela col:nth-child(4) { width: 12%; }
.compras-form-tabs .compra-itens-tabela col:nth-child(5) { width: 18%; }
.compras-form-tabs .compra-itens-tabela col:nth-child(6) { width: 13%; }
.compras-form-tabs .compra-itens-tabela col:nth-child(7) { width: 12%; }

.compras-form-tabs .compra-itens-tabela .compra-item-valor .form-control {
  max-width: 100px;
}

.compras-form-tabs .compra-itens-tabela .compra-item-valor .custo-atual-field {
  flex: 0 1 100px;
}

.compras-form-tabs .compra-itens-tabela .custo-atual-cell {
  min-width: 0;
  flex-wrap: nowrap;
  gap: 6px;
}

.compras-form-tabs .item-desc {
  flex-wrap: wrap;
}

.compras-form-tabs .item-desc > span:not(.chip) {
  white-space: normal;
}

.compras-form-tabs .compra-quantidade-descricao > span {
  min-width: 0;
}

.compras-form-tabs .compra-quantidades-tabela .vs__selected {
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
}

@container compra (max-width: 680px) {
  .compras-form-tabs .compra-xml-table-scroll > .table,
  .compras-form-tabs .compra-xml-table-scroll tbody {
    display: block;
  }

  .compras-form-tabs .compra-xml-table-scroll colgroup,
  .compras-form-tabs .compra-xml-table-scroll thead {
    display: none;
  }

  .compras-form-tabs .compra-itens-tabela thead,
  .compras-form-tabs .compra-itens-tabela thead tr {
    display: block;
  }

  .compras-form-tabs .compra-itens-tabela thead th {
    display: none;
  }

  .compras-form-tabs .compra-itens-tabela thead th:first-child {
    display: flex;
    align-items: center;
    gap: 6px;
    width: auto !important;
  }

  .compras-form-tabs .compra-itens-tabela thead th:first-child::after {
    content: "Selecionar todos os itens";
  }

  .compras-form-tabs .compra-xml-table-scroll tbody tr {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    padding: 12px 0;
    border-bottom: 1px solid #e6eaf0;
  }

  .compras-form-tabs .compra-xml-table-scroll td {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
    min-width: 0;
    border: 0;
    text-align: left !important;
  }

  .compras-form-tabs .compra-xml-table-scroll td::before {
    content: attr(data-label);
    color: #5f6b80;
    font-size: 11px;
    font-weight: 600;
  }

  .compras-form-tabs .compra-xml-table-scroll .compra-item-descricao {
    grid-column: 1 / -1;
  }
}

@container compra (max-width: 360px) {
  .compras-form-tabs .compra-xml-table-scroll tbody tr {
    grid-template-columns: minmax(0, 1fr);
  }
}

.card-total-left,
.card-total-right {
  height: 80px !important;
}

.btn.btn-secondary {
  color: var(--primary-color);
  background-color: #fff;
  border-color: #fff;
}

@media (max-width: 767.98px) {
  .compras-impostos-totais {
    grid-template-columns: minmax(0, 1fr);
  }

  .compras-impostos-campos {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .compras-form-page > .card-body {
    padding: 0;
  }

  .compras-form-layout {
    grid-template-columns: clamp(100px, 28vw, 160px) minmax(0, 1fr);
    gap: 8px;
  }

  .compras-form-sidebar {
    gap: 4px;
    padding: 4px;
  }

  .compras-form-sidebar-item {
    padding: 8px 10px;
    min-height: 44px;
    overflow-wrap: break-word;
  }

  .compras-form-tabs.tabs.row {
    padding: 12px;
  }

  .compras-form-tabs > .tab-content.col {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 0;
  }

  .compras-form-tabs .v-select {
    max-width: 100%;
  }

}
</style>
